import React from 'react';
import { alpha, Typography } from '@mui/material';
import LoanInfoRow from './LoanInfoRow';
import {
  getInsuranceDisplayAmount,
  LoanRequestInsurance,
} from '../LoanRequestInsurancesPreview/types';

const LABEL_COLOR = alpha('#000000', 0.65);

type Props = {
  insurances: LoanRequestInsurance[];
  periods: number;
};

export default function LoanInsuranceBreakdown({ insurances, periods }: Props) {
  return (
    <>
      {insurances.map((insurance) => (
        <LoanInfoRow
          key={insurance.id}
          label={(
            <Typography variant="caption" color={LABEL_COLOR} component="span" sx={{ pl: 2 }}>
              {insurance.insurance.label}
            </Typography>
          )}
          value={getInsuranceDisplayAmount(insurance, periods)}
          size="small"
          color={LABEL_COLOR}
          currency={{
            abbreviation: insurance.value.currency,
            precision: insurance.value.precision,
          }}
        />
      ))}
    </>
  );
}
